import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'helocPurpose',
    label: 'Additional Loan Purpose',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'additionalLoanDrawAmount',
    label: 'Draw Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'lienPriority',
    label: 'Lien Priority',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'baseLoanAmount',
    label: 'Loan Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'loanPurpose',
    label: 'Purpose',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'downPayment',
    label: 'Down Payment',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'buyDown',
    label: 'Buy Down',
    levelType: AutoLockFormsLevelType.FIELD,
  },

  {
    name: 'refinancePurpose',
    label: 'Purpose of Refinance',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'cashOutAmount',
    label: 'Cash Out Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'tangibleNetBenefitReason',
    label: 'Tangible Net Benefit Reason',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'tangibleNetBenefitCurrentInterestRate',
    label: 'Current Interest Rate',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'tangibleNetBenefitCurrentAmortizationPeriodMonths',
    label: 'Current Amortization Period (Months)',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'tangibleNetBenefitDescription',
    label: 'Describe Tangible Net Benefit',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'totalLoanAmount',
    label: 'Total Loan Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'vaTotalEntitlement',
    label: 'VA Total Entitlement',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isEscrowed',
    label: 'Escrow',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isTaxesEscrowed',
    label: 'Taxes Escrow',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isInsuranceEscrowed',
    label: 'Insurance Escrow',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const loanDetailsForm = {
  name: FormNames.LOAN_DETAILS,
  label: 'Loan Details',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
